import React, { useState, useEffect }  from 'react';

const SearchBar = (props) => {
  const { strings, updateQuery } = props;
  const [searchTerm, setSearchTearm] = useState("");
  const [diaplayFilters, toggleFilters] = useState(false);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if(searchTerm !== "") {
        updateQuery(searchTerm);
      }
    }, 300)

    return () => clearTimeout(delayDebounceFn)
  }, [searchTerm, updateQuery])

  const handleChange = (value) => {
    setSearchTearm(value);
  };

  const showFilter = () => {
    const { showFilters } = props
    toggleFilters(!diaplayFilters);
    showFilters(!diaplayFilters);
  };

  return (
    <div className="search-bar">
      <div className="search">
        <input
          type='text'
          placeholder={`${strings.search}`}
          value={searchTerm}
          onChange={ (e) => handleChange(e.target.value)}
        />
        <svg className="icon" id="icon-search" viewBox="0 0 30 32" width="100%" height="100%">
          <path d="M20.571 14.857q0-3.304-2.348-5.652t-5.652-2.348-5.652 2.348-2.348 5.652 2.348 5.652 5.652 2.348 5.652-2.348 2.348-5.652zM29.714 29.714q0 0.929-0.679 1.607t-1.607 0.679q-0.964 0-1.607-0.679l-6.125-6.107q-3.196 2.214-7.125 2.214-2.554 0-4.884-0.991t-4.018-2.679-2.679-4.018-0.991-4.884 0.991-4.884 2.679-4.018 4.018-2.679 4.884-0.991 4.884 0.991 4.018 2.679 2.679 4.018 0.991 4.884q0 3.929-2.214 7.125l6.125 6.125q0.661 0.661 0.661 1.607z"></path>
        </svg>
      </div>
      <button className={`filter-toggle ? "filter-toggle--active" : '' }`} onClick={showFilter}>
        <svg className="icon" id="icon-search" viewBox="0 0 12 12.01" width="100%" height="100%">
          <path d="M11.44,0A.55.55,0,0,1,12,.56a.54.54,0,0,1-.16.4L7.5,5.3v6.14a.52.52,0,0,1-.3.5.57.57,0,0,1-.59,0L4.73,10.59a.58.58,0,0,1-.23-.47V5.3L.16,1A.54.54,0,0,1,0,.56.55.55,0,0,1,.56,0Z"/>
        </svg>
        {`${strings.filters}`}
      </button>
    </div>
  )
}

export default SearchBar;
